<template>
  <div class="auth-bg">
    <div class="auth-overlay">
      <div class="auth-card">
        <!-- Logo + Tên hệ thống -->
        <div class="auth-header">
          <img src="/tt-logo.jpg" alt="TT" class="auth-logo-img" />
          <div class="auth-titles">
            <p class="auth-brand">TT LOGISTICS</p>
            <p class="auth-subtitle">Hệ thống Quản trị Vận tải</p>
          </div>
        </div>

        <RouterView />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style scoped>
.auth-bg {
  min-height: 100vh;
  background: url('/background-login.jpg') center / cover no-repeat;
}

.auth-overlay {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 30, 60, 0.45);
}

.auth-card {
  background: rgba(255, 255, 255, 0.97);
  border-radius: 16px;
  padding: 36px 40px 40px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);
}

.auth-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 28px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e5e7eb;
}

.auth-logo-img {
  width: 52px;
  height: 52px;
  object-fit: contain;
  border-radius: 8px;
}

.auth-titles {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.auth-brand {
  font-size: 18px;
  font-weight: 800;
  color: #13baee;
  letter-spacing: 0.5px;
  line-height: 1.2;
  margin: 0;
}

.auth-subtitle {
  font-size: 12px;
  color: #6b7280;
  margin: 0;
}
</style>
